import { render, staticRenderFns } from "./SouscriptionProjet.vue?vue&type=template&id=4b39a8a5&scoped=true&"
import script from "./SouscriptionProjet.vue?vue&type=script&lang=js&"
export * from "./SouscriptionProjet.vue?vue&type=script&lang=js&"
import style0 from "./SouscriptionProjet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SouscriptionProjet.vue?vue&type=style&index=1&id=4b39a8a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39a8a5",
  null
  
)

export default component.exports